import reactLazyWithRetry from '@fatso83/retry-dynamic-import/react-lazy';

export const LazyEnforcementStatementDialog = reactLazyWithRetry(() =>
  import('./EnforcementStatementDialog').then((module) => ({
    default: module.EnforcementStatementDialog,
  }))
);
